import React, { useState, useEffect, useContext } from "react";
import { filter, isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Container } from "reactstrap";
import SearchContainer from "./components/SearchContainer";
import ProvidersTable from "./components/ProvidersTable";
import { GlobalContext } from "globalStates/Store";
import ErrorBoundary from "components/ErrorBoundary";
import useAxios from "hooks/useAxios";
import { onExport, getUpdatedFilter } from "utils/helper";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

const initialFilterBySearch = {
  coveredEntityName: "",
};

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "modifiedDate",
  order: "desc",
  filters: [],
};

let selectedCoveredEntity = {};

const Providers = (props) => {
  const { orgId } = props;

  const location = useLocation();
  let selectedCEId = window.selectedCoveredEntittyId;
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);

  const API = useAxios();
  const [pageSize, getPageSize] = useState(initialFilters.pageSize)
  const [filterBySearch, setFilterBySearch] = useState(initialFilterBySearch);
  const [coveredEntity, setCoveredEntity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalItem, setTotalItem] = useState(0);
  const [researchNeededCount, setResearchNeededCount] = useState(0);
  const [eligibleCount, setEligibleCount] = useState(0);
  const [inEligibleCount, setInEligibleCount] = useState(0);
  const [reFetch, setFetch] = useState(1);
  const [reset, setReset] = useState(false);
  const [resetFlag, SetResetFlag] = useState(false);

  const [colFilter, setColFilter] = useState([]);
  const [isOpenProgram, setOpenProgram] = useState(false);
  let { tenantID, coveredEntityID } = selectedCoveredEntity;
  const {
    gloabalStates: { claimListTenantID },
  } = useContext(GlobalContext);

  // const fetchProvidersList = async (pageDetails = {}, hasColumnFilter) => {
  //   let filter = { ...pageDetails };
  //   if (hasColumnFilter) {
  //     filter.filters = [...initialFilters.filters, ...pageDetails.filters];
  //     initialFilters.filters = [...initialFilters.filters];
  //   } else {
  //     initialFilters = { ...initialFilters, ...pageDetails };
  //   }
  //   let { tenantID, coveredEntityID } = selectedCoveredEntity;

  //   if (!tenantID) return null;
  //   setLoading(true);
  //   try {
  //     let countData = await API.get(
  //       `/${tenantID}/CEProvider/geteligibilityforce/${coveredEntityID}`
  //     );

  //     if (countData) {
  //       let result = countData.data;
  //       setResearchNeededCount(result.researchNeededCount);
  //       setEligibleCount(result.eligibleCount);
  //       setInEligibleCount(result.inEligibleCount);
  //     }

  //     const { data } = await API.post(
  //       `/${tenantID}/CEProvider/all/${coveredEntityID}`,
  //       filter
  //     );
  //     if (data) {
  //       setData(data.items);
  //       setTotalItem(data.totalRecords);
  //     } else {
  //       setData([]);
  //       setTotalItem(0);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     setData([]);
  //     setTotalItem(0);
  //   }
  // };

  // const onHandleManualProgram = () => {
  //   setOpenProgram(!isOpenProgram);
  // }

  // const onManualSearch = () => {
  //   setOpenProgram(true);

  // }
  const fetchProvidersList = async (pageDetails = {}, hasColumnFilter) => {
    let filter = { ...pageDetails };

    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      initialFilters.filters = [...initialFilters.filters];
      initialFilters.order = pageDetails.order;
      initialFilters.orderBy = pageDetails.orderBy;
    } else {
      initialFilters = { ...initialFilters, ...pageDetails };
    }

    const { tenantID, coveredEntityID } = selectedCoveredEntity;
    if (!tenantID) return null;

    setLoading(true);

    getPageSize(filter.pageSize)

    try {
      const [countData, listData] = await Promise.all([
        API.get(
          `/${tenantID}/CEProvider/geteligibilityforce/${coveredEntityID}`
        ),
        API.post(`/${tenantID}/CEProvider/all/${coveredEntityID}`, filter),
      ]);

      if (countData?.data) {
        const result = countData.data;
        setResearchNeededCount(result.researchNeededCount);
        setEligibleCount(result.eligibleCount);
        setInEligibleCount(result.inEligibleCount);
      }

      if (listData?.data) {
        setData(listData.data.items);
        setTotalItem(listData.data.totalRecords);
      } else {
        setData([]);
        setTotalItem(0);
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
      setData([]);
      setTotalItem(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    selectedCoveredEntity = {};
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "modifiedDate",
      order: "desc",
      filters: [],
    };
  }, []);

  useEffect(() => {
    handleSearch(filterBySearch);
  }, [reFetch]);

  const handleSearch = async (filters) => {
    const { coveredEntityName, providerID, eligibleFlag } = filters;
    initialFilters = {
      currentPage: initialFilters.currentPage,
      pageSize: initialFilters.pageSize,
      orderBy: initialFilters.orderBy,
      order: initialFilters.order,
      filters: [],
    };

    setColFilter((pre) => !pre);
    setFilterBySearch(filters);
    if (coveredEntityName && !isEmpty(coveredEntityName)) {
      initialFilters.filters = getUpdatedFilter(
        "coveredEntityID",
        parseInt(coveredEntityName),
        initialFilters
      );
    }
    if (providerID) {
      initialFilters.filters = getUpdatedFilter(
        "providerID",
        providerID.id,
        initialFilters
      );
    }

    if (eligibleFlag != "-1") {
      initialFilters.filters = getUpdatedFilter(
        'ISNULL(eligibleFlag,"")',
        eligibleFlag,
        initialFilters
      );
    }

    initialFilters.currentPage = 1;
    await fetchProvidersList(initialFilters);
  };

  const handlePageChange = (pageDetails, hasFilter) => {
    if (hasFilter) {
      fetchProvidersList(pageDetails, true);
    } else {
      fetchProvidersList(pageDetails);
    }
  };

  const handleReset = () => {
    setData([]);
    setReset((pre) => !pre);
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: "modifiedDate",
      order: "desc",
      filters: [],
    };
    setTotalItem(0);
    setResearchNeededCount(0);
    setInEligibleCount(0);
    setInEligibleCount(0);
    setEligibleCount(0);
    selectedCoveredEntity = {};
    SetResetFlag(true);
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    await fetchProvidersList(columnFilters, true);
    setColFilter(columnFilters);
  };

  const fetchAgain = (id) => {
    setFetch(id);
  };
  const handleExport = () => {
    const { tenantID, coveredEntityID } = selectedCoveredEntity;
    const { access_token } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/CEProvider/ExportAll/${coveredEntityID}?access_token=${access_token}`;
    onExport(action, initialFilters);
  };
  const handleExport2 = async () => {
    const mergedFiltersObj = {
      ...initialFilters,
      filters: [
        ...(initialFilters?.filters || []),
        ...(colFilter?.filters || []),
      ]
    };
    var additionalCriteria = {};
    const datafilter = mergedFiltersObj.filters.filter((item) => {
      return (
        item.filterValue == ""
      )
    })
    let { tenantID, coveredEntityID } = selectedCoveredEntity;
    console.log(datafilter, "data")
    if (datafilter.length > 0) {
      mergedFiltersObj.filters = getUpdatedFilter(
        "ISNULL(eligibleFlag,\"\")",
        (datafilter ? datafilter[0].filterValue : provider),
        mergedFiltersObj
      )
    }
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.CEId = coveredEntityID;
    //filterObj.CoveredEntityIDS = coveredEntityID;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "provider";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(mergedFiltersObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };

  const handleUpdateEntity = (entity) => {
    selectedCoveredEntity = entity;
  };

  const refetch = (hasReset) => {
    setColFilter([]);
    if (hasReset) {
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
        pageSize: pageSize,
        // order: "desc",
        // orderBy: "modifiedDate",
      };
    }
    fetchProvidersList(initialFilters);
  };
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };

  useEffect(() => {
    handleReset()
  }, [orgId])
  return (
    <div>
      <Container fluid className="width_info">
        <div className={collapseSider ? "mb-0" : "mb-3"}>
          <Card className="border-0 shadow-top" hidden={collapseSider}>
            <CardBody className="section-devider-border">
              <ErrorBoundary>
                <SearchContainer
                  filterBySearch={filterBySearch}
                  onSearch={handleSearch}
                  orgId={orgId}
                  coveredEntity={coveredEntity}
                  onReset={handleReset}
                  providerFilters={[]}
                  handleUpdateEntity={handleUpdateEntity}
                  selectedCEId={selectedCEId}
                // onManualSearch={onManualSearch}
                />
              </ErrorBoundary>
            </CardBody>
          </Card>
        </div>
        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <ErrorBoundary>
              <ProvidersTable
                data={data}
                loading={loading}
                totalSize={totalItem}
                onPageChange={handlePageChange}
                selectedCoveredEntity={claimListTenantID}
                apiFilter={initialFilters}
                formReset={reset}
                onSearchColumnFilters={handleSearchColumnFilters}
                setColFilterFalse={colFilter}
                fetchAgain={fetchAgain}
                onExport={handleExport2}
                setLoading={setLoading}
                refetch={refetch}
                coveredEntityTenantID={selectedCoveredEntity?.tenantID}
                researchNeededCount={researchNeededCount}
                eligibleCount={eligibleCount}
                inEligibleCount={inEligibleCount}
                resetFlag={resetFlag}
                SetResetFlag={SetResetFlag}
                collapseSider={collapseSider}
                toggleSider={toggleSider}

              />
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      {/* <Drawer
        direction='end'
        title='Auto-Approve Provider & Patient Combinations'
        isOpen={isOpenProgram}
        toggle={onHandleManualProgram}
        size="lg"
      >
        <PatientProviderMap
          //  hasEditable={true}
          onClose={onHandleManualProgram}
          selectedCoveredEntity={selectedCoveredEntity}
        />
      </Drawer> */}
    </div>
  );
};

export default Providers;
